import { React, useRef, useState, useEffect } from "react";
import TextInput from "../../UIComponent/TextInput";
import DateInput from "../../inputs/DateInput";

import moment from "moment";
import ButtonLoader from "../../common/buttonLoader/ButtonLoader";
import NumberInput from "../../UIComponent/NumberInput";

function EmploymentInformation(props) {
    const textRef = useRef();
    const [value] = useState();

    useEffect(() => {
        if (textRef && textRef.current) {
            textRef.current.style.height = "0px";
            const taHeight = textRef.current.scrollHeight;
            textRef.current.style.height = taHeight + "px";
        }
    }, [value]);
    //const [openEmploymentModal, setOpenEmploymentModal] = useState(false);
    // const tierHighlights = {
    //     1: {
    //         atLeastText: "at least one",
    //         minSizeText: "minimum size of $150m"
    //     },
    //     2: {
    //         atLeastText: "at least one",
    //         minSizeText: "minimum size of $85m"
    //     },
    //     3: {
    //         atLeastText: "at least one",
    //         minSizeText: "minimum size of $25m"
    //     },
    //     4: {
    //         atLeastText: "One or more",
    //         minSizeText: "combined total size of at least $10m"
    //     }
    // };

    // const tierId = props.applicationTierId;
    // const highlight = tierHighlights[tierId];

    return (
        <>
            <div className="container mx-auto">
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12">
                        <div className="bg-gray-box  ">
                            <div className="form-info-title">
                                <h4 className="text-[#2d2d2d] form-info-title-txt">
                                    Employment History
                                </h4>
                                {/* <div className="mt-2 mb-3">
                                    <p style={{ color: "#2d2d2d" }}>
                                        For employment in the construction industry, include the project(s) you have managed or are involved in. Include the required qualifying project (i.e., Completed{" "}
                                        <span className="underline font-semibold">{highlight.atLeastText}</span>{" "}
                                        construction project of{" "}
                                        <span className="underline font-semibold">{highlight.minSizeText}</span>{" "}
                                        in the capacity of Project Manager and above).
                                    </p>

                                    <p className="mt-2" style={{ color: "#2d2d2d" }}>
                                        For employment in non-construction companies, briefly describe your roles and responsibilities.
                                    </p>
                                </div> */}

                            </div>
                            <div className="col-span-12 ">
                                <div className="mb-2">
                                </div>
                                <div className="table-section">
                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead className="bg-[#005b9c] text-white">
                                                <tr>
                                                    <th className="text-left py-3 px-5">
                                                        Name of Company
                                                    </th>
                                                    <th className="text-left py-3 px-5">
                                                        Job Title
                                                    </th>
                                                    <th className="text-left py-3 px-5">
                                                        Duration of Employment
                                                    </th>
                                                    <th className="text-left py-3 px-5">
                                                        Date From
                                                    </th>
                                                    <th className="text-left py-3 px-5">
                                                        Date To
                                                    </th>

                                                    <th className="text-left py-3 px-5">
                                                        Company Type
                                                    </th>
                                                    <th className="text-left py-3 px-5"></th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-sm custom-tbody">
                                                {props?.employmentInformation?.employmentInformations
                                                    // ?.filter(empHistory =>
                                                    //     empHistory.isConstruction === props.employmentInformationdetail.isConstruction
                                                    // )
                                                    .map((empHistory, key) => (
                                                        <tr
                                                            className="bg-[#eeeeee] text-black border-t-4 border-[#ffffff]"
                                                            key={key}
                                                        >
                                                            <td className="text-left py-2 px-5">{empHistory.companyName}</td>
                                                            <td className="text-left py-2 px-5">{empHistory.jobTitle}</td>
                                                            <td className="text-left py-2 px-5">{empHistory.employmentDuration}</td>
                                                            <td className="text-left py-2 px-5">
                                                                {empHistory.employmentFromDate
                                                                    ? moment(empHistory.employmentFromDate).format('DD MMM YYYY')
                                                                    : ''}
                                                            </td>

                                                            <td className="text-left py-2 px-5">
                                                                {empHistory.employmentToDate
                                                                    ? moment(empHistory.employmentToDate).format('DD MMM YYYY')
                                                                    : ''}
                                                            </td>
                                                            <td className="text-left py-2 px-5">
                                                                {empHistory.isConstruction ? 'Construction Company' : 'Non-Construction Company'}
                                                            </td>
                                                            <td className="py-2 px-5 text-center">
                                                                <div className="flex gap-2">
                                                                    <button
                                                                        className="action-btn"
                                                                        onClick={() => {
                                                                            props.getEmploymentHistoryById(empHistory.employmentHistoryId);
                                                                            props.setOpenEmploymentModal(true);
                                                                        }}
                                                                    >
                                                                        <img className="min-h-[30px] min-w-[30px]" src="../edit.png" alt="" />
                                                                    </button>

                                                                    <button
                                                                        className="action-btn"
                                                                        onClick={() =>
                                                                            props.deleteCpasEmploymentHistory(empHistory.employmentHistoryId)
                                                                        }
                                                                    >
                                                                        <img
                                                                            className="min-h-[30px] min-w-[30px]"
                                                                            src="../delete-icon.svg"
                                                                            alt=""
                                                                        />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>

                            </div>

                            <div className="grid grid-cols-12 gap-4 w-full justify-between mt-6">
                                <div className="col-span-12">
                                    <h2 className="input-title mb-4">
                                        Company Type
                                        <span className="text-[#C00000]"> *</span>
                                    </h2>
                                    <div className="flex items-center w-full">
                                        <div className="flex items-center">
                                            <input
                                                type="radio"
                                                name="isConstruction"
                                                value="true"
                                                checked={props.employmentInformationdetail.isConstruction === true}
                                                onChange={() => props.handleEmploymentConstructionChange(true)}
                                                className="form-radio h-5 w-5 text-blue-600"
                                            />
                                            <span className="ml-3">Construction Company</span>
                                        </div>

                                        <div className="flex items-center ml-10">
                                            <input
                                                type="radio"
                                                name="isConstruction"
                                                value="false"
                                                checked={props.employmentInformationdetail.isConstruction === false}
                                                onChange={() => props.handleEmploymentConstructionChange(false)}
                                                className="form-radio h-5 w-5 text-blue-600"
                                            />
                                            <span className="ml-3">Non-construction Company</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12">
                                <div className="flex justify-end">
                                    <button
                                        className="btn btn-border-caps"

                                        onClick={() => {
                                            props.resetHandler("EmploymentHistory");   //  // 👈 clear fields first
                                            props.setOpenEmploymentModal(true);
                                        }}
                                    >
                                        <span className="fa fa-plus"></span>
                                        <span className="ml-2">Add</span>
                                    </button>
                                </div>
                            </div>
                            <div className="first-professional-reference">
                                <div className="form-info-title">

                                    <h4 className="text-[#2d2d2d] form-info-title-txt">
                                        Professional References
                                    </h4>
                                    <p className="lg:mt-4">In support of your application, list two professional references whom we can contact for purposes relating to your application for accreditation, or to validate any of your professional experience(s) in the construction industry.
                                    </p>



                                    {/* <span className="mt-1 block">Rereferences will receive an email to validate status as professional reference</span> */}
                                </div>
                                <div className="col-span-12 mt-8">
                                    <h2 className="text-xl font-semibold">
                                        First Reference
                                    </h2>
                                </div>
                                <div className="grid grid-cols-12 md:gap-10 md:gap-4 gap-3 w-full justify-between mt-5">
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            First Name of First Reference
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="referenceFirstName"
                                                value={props.oganisationReference.referenceFirstName}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField("referenceFirstName", "Employement_Information_First")
                                            // }
                                            />
                                        </div>
                                    </div>
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Last Name of Reference
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="referenceLastName"
                                                value={props.oganisationReference.referenceLastName}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "referenceLastName",
                                            //         "Employement_Information_First"
                                            //     )
                                            // }
                                            />
                                        </div>
                                    </div>
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Email Address
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="referenceEmailAddress"
                                                value={props.oganisationReference.referenceEmailAddress}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "referenceEmailAddress",
                                            //         "Employement_Information_First"
                                            //     )
                                            // }
                                            />
                                        </div>
                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Organisation
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="dropdown">

                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="referenceOrganisation"
                                                value={props.oganisationReference.referenceOrganisation}
                                                identity="Caps_Application"
                                                handleChange={(e) => props.handleChange(e, "Professional_References")}
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "referenceOrganisation",
                                            //         "Employement_Information_First"
                                            //     )
                                            // }
                                            />

                                        </div>
                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Organisation Address
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="referenceOrganisationAddress"
                                                value={props.oganisationReference.referenceOrganisationAddress}
                                                identity="Caps_Application"
                                                handleChange={(e) => props.handleChange(e, "Professional_References")}
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "referenceOrganisationAddress",
                                            //         "Employement_Information_First"
                                            //     )
                                            // }
                                            />
                                        </div>
                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Relationship
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="referenceRelationship"
                                                value={props.oganisationReference.referenceRelationship}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "referenceRelationship",
                                            //         "Employement_Information_First"
                                            //     )
                                            // }
                                            />
                                        </div>
                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Contact Number
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="referenceContactNumber"
                                                value={props.oganisationReference.referenceContactNumber}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "referenceContactNumber",
                                            //         "Employement_Information_First"
                                            //     )
                                            // }
                                            />
                                        </div>
                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Length of Period Known to Applicant (In Months)
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="dropdown">
                                            <TextInput
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                name="periodKnownInMonths"
                                                value={props.oganisationReference.periodKnownInMonths}
                                                identity="Caps_Application"
                                                handleChange={(e) => {
                                                    const onlyNums = e.target.value.replace(/\D/g, "");
                                                    props.handleChange({ target: { name: "periodKnownInMonths", value: onlyNums } }, "Professional_References");
                                                }}
                                            // onBlur={() => props.validateField("periodKnownInMonths", "Employement_Information_First")}
                                            />

                                        </div>
                                    </div>
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3 flex items-center whitespace-nowrap">
                                            Upload Document
                                            <span className="text-[#C00000]"> *</span>

                                            <span className="input text-[#808080] ml-1 inline-flex items-center whitespace-nowrap">
                                                (PDF, DOC, DOCX, JPG, JPEG, and PNG files only)

                                                <button
                                                    type="button"
                                                    className="underline text-[#005b9c] font-[500] ml-4 whitespace-nowrap"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        props.GetCPASMemberFiles(
                                                            "Templates",
                                                            "ProfessionalReferencesTemplate.pdf"
                                                        );
                                                    }}
                                                >
                                                    Download template
                                                </button>
                                            </span>
                                        </h2>
                                        <div className="flex item-center flex-col">
                                            {
                                                props && props.isLettersOfProffesion ?
                                                    <ButtonLoader type='btn btn-caps' />
                                                    :
                                                    (
                                                        <>
                                                            <div className='eduinfo-uplaod-button flex'>
                                                                <form className="custom-uploader custom-file-upload-btn flex">
                                                                    <div className='border border-[#f3f3f3] btn btn-caps cursor-pointer'>
                                                                        <label
                                                                            htmlFor={`Letters_Of_Proffesion`}
                                                                            className="text-uplod text-white cursor-pointer"
                                                                        >
                                                                            Upload File
                                                                        </label>
                                                                        <input
                                                                            className="sr-only"
                                                                            id={`Letters_Of_Proffesion`}
                                                                            type="file"
                                                                            onChange={(event) => props.onFileChange(event, "Letters_Of_Proffesion")}
                                                                        />
                                                                    </div>
                                                                </form>
                                                                {props && props.oganisationReference.referenceDocumentFilePath ?
                                                                    <div className="w-auto">
                                                                        <button
                                                                            className="ml-5 2xl:px-7 lg:px-5 py-2 btn border text-[#005b9c] font-semibold tracking-normal underline"
                                                                            style={{ borderColor: '#005b9c' }}
                                                                            onClick={() =>
                                                                                props.GetCPASMemberFiles(
                                                                                    'Letters_Of_Proffesion',
                                                                                    props.oganisationReference.referenceDocumentFilePath
                                                                                )
                                                                            }
                                                                        >
                                                                            View File
                                                                        </button>

                                                                    </div>
                                                                    :
                                                                    null
                                                                }
                                                            </div>
                                                        </>
                                                    )
                                            }
                                            {
                                                props && props.oganisationReference.referenceDocumentFilePath ?
                                                    (
                                                        <div className='mt-5 file-uploaded-txt flex items-center'>
                                                            {/* <Image src='/check-orange.png' className='w-[25px] mr-3' alt='' /> */}
                                                            <span className='text-[#000]'>
                                                                {props.oganisationReference.referenceDocumentFilePath}
                                                            </span>
                                                        </div>
                                                    )
                                                    :
                                                    null
                                            }
                                        </div>

                                    </div>

                                    {/* ================= SECOND REFERENCE ================= */}

                                    <div className="col-span-12 mt-8">
                                        <h2 className="text-xl font-semibold">
                                            Second Reference
                                        </h2>
                                    </div>

                                    {/* Second Reference First Name */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            First Name of Second Reference
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>

                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="secondReferenceFirstName"
                                                value={props.oganisationReference.secondReferenceFirstName}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "secondReferenceFirstName",
                                            //         "Employement_Information_Second"
                                            //     )
                                            // }
                                            />

                                            {/* <ValidationText
                                            error={
                                                props.validStateSecondReference?.error?.secondReferenceFirstName
                                            }
                                        /> */}
                                        </div>
                                    </div>


                                    {/* Second Reference Last Name */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Last Name of Second Reference
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>

                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="secondReferenceLastName"
                                                value={props.oganisationReference.secondReferenceLastName}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "secondReferenceLastName",
                                            //         "Employement_Information_Second"
                                            //     )
                                            // }
                                            />

                                            {/* <ValidationText
                                            error={
                                                props.validStateSecondReference?.error?.secondReferenceLastName
                                            }
                                        /> */}
                                        </div>
                                    </div>


                                    {/* Second Reference Email */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Email Address
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>

                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="secondReferenceEmailAddress"
                                                value={props.oganisationReference.secondReferenceEmailAddress}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "secondReferenceEmailAddress",
                                            //         "Employement_Information_Second"
                                            //     )
                                            // }
                                            />
                                            {/* 
                                        <ValidationText
                                            error={
                                                props.validStateSecondReference?.error?.secondReferenceEmailAddress
                                            }
                                        /> */}
                                        </div>
                                    </div>


                                    {/* Second Reference Organisation */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Organisation
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>

                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="secondReferenceOrganisation"
                                                value={props.oganisationReference.secondReferenceOrganisation}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "secondReferenceOrganisation",
                                            //         "Employement_Information_Second"
                                            //     )
                                            // }
                                            />

                                            {/* <ValidationText
                                            error={
                                                props.validStateSecondReference?.error?.secondReferenceOrganisation
                                            }
                                        /> */}
                                        </div>
                                    </div>


                                    {/* Second Reference Organisation Address */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Organisation Address
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>

                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="secondReferenceOrganisationAddress"
                                                value={
                                                    props.oganisationReference.secondReferenceOrganisationAddress
                                                }
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "secondReferenceOrganisationAddress",
                                            //         "Employement_Information_Second"
                                            //     )
                                            // }
                                            />
                                            {/* 
                                        <ValidationText
                                            error={
                                                props.validStateSecondReference?.error
                                                    ?.secondReferenceOrganisationAddress
                                            }
                                        /> */}
                                        </div>
                                    </div>


                                    {/* Second Reference Relationship */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Relationship
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>

                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="secondReferenceRelationship"
                                                value={props.oganisationReference.secondReferenceRelationship}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "secondReferenceRelationship",
                                            //         "Employement_Information_Second"
                                            //     )
                                            // }
                                            />

                                            {/* <ValidationText
                                            error={
                                                props.validStateSecondReference?.error
                                                    ?.secondReferenceRelationship
                                            }
                                        /> */}
                                        </div>
                                    </div>


                                    {/* Second Reference Contact Number */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Contact Number
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>

                                        <div className="dropdown">
                                            <TextInput
                                                placeholder=""
                                                type="text"
                                                name="secondReferenceContactNumber"
                                                value={props.oganisationReference.secondReferenceContactNumber}
                                                identity="Caps_Application"
                                                handleChange={(e) =>
                                                    props.handleChange(e, "Professional_References")
                                                }
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "secondReferenceContactNumber",
                                            //         "Employement_Information_Second"
                                            //     )
                                            // }
                                            />

                                            {/* <ValidationText
                                            error={
                                                props.validStateSecondReference?.error
                                                    ?.secondReferenceContactNumber
                                            }
                                        /> */}
                                        </div>
                                    </div>


                                    {/* Second Reference Period Known */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3">
                                            Length of Period Known to Applicant (In Months)
                                            <span className="text-[#C00000]"> *</span>
                                        </h2>

                                        <div className="dropdown">
                                            <TextInput
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                name="secondPeriodKnownInMonths"
                                                value={props.oganisationReference.secondPeriodKnownInMonths}
                                                identity="Caps_Application"
                                                handleChange={(e) => {
                                                    const onlyNums = e.target.value.replace(/\D/g, "");

                                                    props.handleChange(
                                                        {
                                                            target: {
                                                                name: "secondPeriodKnownInMonths",
                                                                value: onlyNums
                                                            }
                                                        },
                                                        "Professional_References"
                                                    );
                                                }}
                                            // onBlur={() =>
                                            //     props.validateField(
                                            //         "secondPeriodKnownInMonths",
                                            //         "Employement_Information_Second"
                                            //     )
                                            // }
                                            />

                                            {/* <ValidationText
                                            error={
                                                props.validStateSecondReference?.error
                                                    ?.secondPeriodKnownInMonths
                                            }
                                        /> */}
                                        </div>
                                    </div>


                                    {/* Second Reference Upload Document */}
                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-3 flex items-center whitespace-nowrap">
                                            Upload Document
                                            <span className="text-[#C00000]"> *</span>

                                            <span className="input text-[#808080] ml-1 inline-flex items-center whitespace-nowrap">
                                                (PDF, DOC, DOCX, JPG, JPEG, and PNG files only)

                                                <button
                                                    type="button"
                                                    className="underline text-[#005b9c] font-[500] ml-4 whitespace-nowrap"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        props.GetCPASMemberFiles(
                                                            "Templates",
                                                            "ProfessionalReferencesTemplate.pdf"
                                                        );
                                                    }}
                                                >
                                                    Download template
                                                </button>
                                            </span>
                                        </h2>


                                        <div className="flex item-center flex-col">

                                            {props && props.isSecondLettersOfProffesion ?
                                                <ButtonLoader type="btn btn-caps" />
                                                :
                                                (
                                                    <>
                                                        <div className="eduinfo-uplaod-button flex">

                                                            <form className="custom-uploader custom-file-upload-btn flex">
                                                                <div className="border border-[#f3f3f3] btn btn-caps cursor-pointer">

                                                                    <label
                                                                        htmlFor="Second_Letters_Of_Proffesion"
                                                                        className="text-uplod text-white cursor-pointer"
                                                                    >
                                                                        Upload File
                                                                    </label>

                                                                    <input
                                                                        className="sr-only"
                                                                        id="Second_Letters_Of_Proffesion"
                                                                        type="file"
                                                                        onChange={(event) =>
                                                                            props.onFileChange(
                                                                                event,
                                                                                "Second_Letters_Of_Proffesion"
                                                                            )
                                                                        }
                                                                    />

                                                                </div>
                                                            </form>

                                                            {props &&
                                                                props.oganisationReference.secondReferenceDocumentFilePath ? (
                                                                <div className="w-auto">

                                                                    <button
                                                                        className="ml-5 2xl:px-7 lg:px-5 py-2 btn border text-[#005b9c] font-semibold tracking-normal underline"
                                                                        style={{ borderColor: "#005b9c" }}
                                                                        onClick={() =>
                                                                            props.GetCPASMemberFiles(
                                                                                "Letters_Of_Proffesion",
                                                                                props.oganisationReference
                                                                                    .secondReferenceDocumentFilePath
                                                                            )
                                                                        }
                                                                    >
                                                                        View File
                                                                    </button>

                                                                </div>

                                                            ) : null}

                                                        </div>

                                                    </>
                                                )

                                            }

                                            {props &&
                                                props.oganisationReference.secondReferenceDocumentFilePath ? (
                                                <div className="mt-5 file-uploaded-txt flex items-center">
                                                    <span className="text-[#000]">
                                                        {props.oganisationReference.secondReferenceDocumentFilePath}
                                                    </span>
                                                </div>
                                            ) : null}

                                            {/* <ValidationText
                                            error={
                                                props.validStateSecondReference?.error
                                                    ?.secondReferenceDocumentFilePath
                                            }
                                        /> */}

                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div className="flex flex-wrap justify-end mt-16">


                            {props && props.isSubmitLoader ? (
                                <ButtonLoader className="bg-[#005b9c] hover:bg-[#004a80] text-white" />

                            ) : (
                                <button
                                    className="btn btn-caps"
                                    onClick={() => props.submitEmploymentInformation("isSave")}
                                >
                                    <span className="">Save</span>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {props.openEmploymentModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                    <div className="bg-white w-[95%] max-w-6xl rounded-lg shadow-lg p-6 relative max-h-[90vh] overflow-y-auto">

                        {/* HEADER */}
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-lg font-semibold">
                                Add Employment History
                            </h3>
                            <button
                                className="text-xl"
                                onClick={() => props.setOpenEmploymentModal(false)}
                            >
                                ✕
                            </button>
                        </div>

                        {/* ================= FORM BODY ================= */}
                        <div className="grid grid-cols-12 gap-4">

                            {/* Name of Company */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">Name of Company  <span className="text-[#C00000]"> *</span></h2>
                                <TextInput
                                    placeholder=""
                                    type="text"
                                    name="companyName"
                                    value={props.employmentInformationdetail.companyName}
                                    identity="CAPS_Application"
                                    handleChange={(e) => props.handleChange(e, "Employment_History")}
                                // onBlur={() => props.validateField("companyName", "Employement_Information")}

                                />


                            </div>

                            {/* Position Held */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">Job Title<span className="text-[#C00000]"> *</span></h2>
                                <TextInput
                                    name="jobTitle"
                                    value={props.employmentInformationdetail.jobTitle}
                                    handleChange={(e) => props.handleChange(e, "Employment_History")}
                                //onBlur={() => props.validateField("jobTitle", "Employement_Information")}

                                />

                            </div>

                            {/* Duration */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">Duration of Employment <span className="text-[#C00000]"> *</span></h2>
                                <TextInput
                                    name="employmentDuration"
                                    value={props.employmentInformationdetail.employmentDuration}
                                    handleChange={(e) => props.handleChange(e, "Employment_History")}
                                // onBlur={() => props.validateField("employmentDuration", "Employement_Information")}

                                />

                            </div>

                            {/* Date From */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">Date From <span className="text-[#C00000]"> *</span></h2>
                                <DateInput
                                    name="employmentFromDate"
                                    value={moment(props.employmentInformationdetail.employmentFromDate).format("YYYY-MM-DD")}
                                    handleChange={(e) => props.handleChange(e, "Employment_History")}
                                //onBlur={() => props.validateField("employmentFromDate", "Employement_Information")}

                                />

                            </div>

                            {/* Date To */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">Date To</h2>
                                <DateInput
                                    name="employmentToDate"
                                    value={moment(props.employmentInformationdetail.employmentToDate).format("YYYY-MM-DD")}
                                    handleChange={(e) => props.handleChange(e, "Employment_History")}
                                //  onBlur={() => props.validateField("employmentToDate", "Employement_Information")}

                                />

                            </div>

                            {/* ================= CONSTRUCTION COMPANY ================= */}
                            {props.employmentInformationdetail.isConstruction === true && (
                                // <div className="grid grid-cols-12 gap-4 mt-6">
                                <>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-2">Project(s) Involved<span className="text-[#C00000]"> *</span></h2>
                                        <TextInput
                                            name="projectsInvolved"
                                            value={props.employmentInformationdetail.projectsInvolved}
                                            handleChange={(e) => props.handleChange(e, "Employment_History")}
                                        // onBlur={() => props.validateField("projectsInvolved", "Employement_Information")}

                                        />

                                    </div>

                                    {/* <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-2">Job Title<span className="text-[#C00000]"> *</span></h2>
                                        <TextInput
                                            name="jobTitle"
                                            value={props.employmentInformationdetail.jobTitle}
                                            handleChange={(e) => props.handleChange(e, "Employment_History")}
                                        //onBlur={() => props.validateField("jobTitle", "Employement_Information")}

                                        />

                                    </div> */}

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-2">Contract Value<span className="text-[#C00000]"> *</span></h2>
                                        <TextInput
                                            name="contractValues"
                                            value={props.employmentInformationdetail.contractValues}
                                            handleChange={(e) => props.handleChange(e, "Employment_History")}
                                        //  onBlur={() => props.validateField("contractValues", "Employement_Information")}

                                        />

                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-2">Project Involvement Date From<span className="text-[#C00000]"> *</span></h2>

                                        <DateInput
                                            name="employmentFromYear"
                                            value={moment(props.employmentInformationdetail.employmentFromYear).format("YYYY-MM-DD")}
                                            handleChange={(e) => props.handleChange(e, "Employment_History")}
                                        // onBlur={() => props.validateField("employmentFromYear", "Employement_Information")}

                                        />

                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-2">Project Involvement Date To<span className="text-[#C00000]"> *</span></h2>

                                        <DateInput
                                            name="employmentToYear"
                                            value={moment(props.employmentInformationdetail.employmentToYear).format("YYYY-MM-DD")}
                                            handleChange={(e) => props.handleChange(e, "Employment_History")}
                                        // onBlur={() => props.validateField("employmentToYear", "Employement_Information")}

                                        />

                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-2">Percentage of Involvement<span className="text-[#C00000]"> *</span></h2>
                                        <NumberInput
                                            name="projectInvolvementpercentage"
                                            value={props.employmentInformationdetail.projectInvolvementpercentage}
                                            handleChange={(e) => props.handleChange(e, "Employment_History")}
                                        // onBlur={() => props.validateField("projectInvolvementpercentage", "Employement_Information")}

                                        />

                                    </div>

                                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                        <h2 className="input-title mb-2">Location of Project  <span className="text-[#C00000]"> *</span></h2>
                                        <TextInput
                                            name="locationOfProject"
                                            value={props.employmentInformationdetail.locationOfProject}
                                            handleChange={(e) => props.handleChange(e, "Employment_History")}
                                        // onBlur={() => props.validateField("locationOfProject", "Employement_Information")}

                                        />

                                    </div>

                                    <div className="col-span-12">
                                        <h2 className="input-title mb-2">
                                            Is this a project management role?  <span className="text-[#C00000]"> *</span>
                                        </h2>
                                        <div className="flex gap-10">
                                            <label className="flex items-center">
                                                <input
                                                    type="radio"
                                                    name="isProjectManagementRole"
                                                    value="true"
                                                    checked={props.employmentInformationdetail.isProjectManagementRole === true}
                                                    onChange={props.handleEmploymentRadioChange}
                                                />
                                                <span className="ml-3">Yes</span>
                                            </label>
                                            <label className="flex items-center">
                                                <input
                                                    type="radio"
                                                    name="isProjectManagementRole"
                                                    value="false"
                                                    checked={props.employmentInformationdetail.isProjectManagementRole === false}
                                                    onChange={props.handleEmploymentRadioChange}
                                                />
                                                <span className="ml-3">No</span>
                                            </label>
                                        </div>
                                    </div>
                                </>
                                // </div>
                            )}
                        </div>
                        {/* ================= NON-CONSTRUCTION COMPANY ================= */}
                        {props.employmentInformationdetail.isConstruction === false && (
                            <div className="grid grid-cols-12 gap-4 mt-6">
                                <div className="col-span-12">
                                    <h2 className="input-title mb-2">
                                        Brief Description of Roles and Responsibilities  <span className="text-[#C00000]"> *</span>
                                    </h2>

                                    <textarea
                                        rows="5"
                                        name="rolesAndResponsibilities"
                                        className="w-full"
                                        value={props.employmentInformationdetail.rolesAndResponsibilities}
                                        onChange={(e) => props.handleChange(e, "Employment_History")}
                                    //  onBlur={() => props.validateField("rolesAndResponsibilities", "Employement_Information")}

                                    />

                                </div>
                            </div>
                        )}

                        {/* FOOTER */}
                        <div className="flex justify-end gap-4 mt-8">
                            <button
                                className="btn btn-border-caps"
                                onClick={() => props.setOpenEmploymentModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-caps"
                                onClick={() => {
                                    props.handleAddRemoveDataList("HandleAdd", "EmploymentHistory");
                                    //props.setOpenEmploymentModal(false);
                                }}
                            >
                                Save
                            </button>
                        </div>

                    </div>
                </div>
            )}

        </>
    );
}
export default EmploymentInformation;
